import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon.js';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage.js';
import useLocalStore from '../../../hooks/useLocalStore.js';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJImageInput from '../../../common/components/FJImageInput/FJImageInput.jsx';
import {
    UPLOAD_FILE_TYPE_NO_GIF,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
    UPLOAD_FILE_TYPE,
} from '../../../config/dataConfig/FJGenerateData.js';

const FJImageInputContainer = ({ id }) => {
    useLocalStore();
    const uploadImageInfo = useSelector(state => state.imageToImage.uploadImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);

    const dispatch = useDispatch();

    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const _openMediaLibrary = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    // 上传文件规则
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE, // 上传后的校验使用
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE', 'GIF'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };

    return (
        <FJImageInput
            uploadImageInfo={uploadImageInfo}
            isDraggingFile={isDraggingFile}
            openMediaLibrary={_openMediaLibrary}
            uploadImg={uploadImg}
            acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
            setIsDraggingFile={_setIsDraggingFile}
            style={{
                height: '60px',
                flex: 'none',
                marginBottom: '20px',
            }}
            previewImageStyle={{ left: '559px' }}
            id={id}
        />
    );
};

FJImageInputContainer.propTypes = {
    id: PropTypes.string,
};

export default FJImageInputContainer;
